import { useInView } from '@/hooks/useInView';

export default function CTASection() {
  const [ref, inView] = useInView<HTMLDivElement>();

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-24 bg-gradient-to-br from-primary-600 via-primary-700 to-primary-800 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-primary-500/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-accent-500/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4" />

      <div
        ref={ref}
        className={`relative z-10 max-w-4xl mx-auto text-center transition-all duration-700 ${
          inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}
      >
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 font-heading leading-tight mb-5">
          Build trust into every digital interaction.
        </h2>
        <p className="text-base md:text-lg text-background-200 leading-relaxed max-w-2xl mx-auto mb-8">
          Ardeun powers biometric identity, secure access, trusted email, and anti-spoofing solutions across multiple products and sectors.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-background-50 text-primary-700 font-semibold rounded-full hover:bg-background-100 transition-colors whitespace-nowrap"
          >
            Request a Demo
            <i className="ri-arrow-right-line" />
          </a>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500/30 text-background-50 border border-background-50/30 font-medium rounded-full hover:bg-primary-500/50 transition-colors whitespace-nowrap"
          >
            Talk to Ardeun
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}